import {createElement, FC, ReactNode} from 'react';

export function ConditionalWrapper<Func extends FC<any>>({
  children,
  WrapperComponent,
  wrapperProps,
  condition,
}: {
  children: ReactNode;
  condition: boolean;
  WrapperComponent: Func;
  wrapperProps: Omit<Parameters<Func>[0], 'children'>;
}) {
  return condition ? (
    createElement(WrapperComponent, wrapperProps, children)
  ) : (
    <>{children}</>
  );
}
